import React from 'react';
import PropTypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { EstimatorConfigurator, PageAlert, SummaryPanel } from '@thd-olt-component-react/estimator-configurator';
import { useParams } from '@thd-olt-component-react/router';
import { getBreadcrumbs } from '../utils/getBreadcrumbs';

export const KitchenEstimator = ({ data }) => {
  const staticBreadcrumbs = getBreadcrumbs({ breadcrumbs: data?.config?.breadcrumbs || [] });
  const { itemId: partnerProductId } = useParams();
  const omsId = partnerProductId || '561029';

  return (
    <div className="sui-bg-subtle sui-min-h-screen">
      <div className="sui-w-full 2xl:sui-container sui-mx-auto sui-my-0">
        <div className="sui-grid sui-grid-cols-12 sui-gap-x-5">
          <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row lg:sui-col-span-7">
            <div className="fusion-slot sui-bg-subtle sui-p-3 sui-mb-0">
              <QueryProvider cacheKey="kitchen-estimator-breadcrumbs">
                <Breadcrumbs data={staticBreadcrumbs} />
              </QueryProvider>
            </div>
          </div>
          <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row lg:sui-col-span-5">{/* additional meta info */}</div>
          <div className="sui-col-span-12 sui-flex-col fusion-row lg:sui-ml-3 lg:sui-mr-3 sui-relative sui-z-[100]"><PageAlert position="static" /></div>
          <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row lg:sui-col-span-8 sui-bg-primary lg:sui-ml-3 sui-pl-6 sui-pr-6">
            <EstimatorConfigurator omsId={omsId} />
          </div>
          <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row lg:sui-col-span-4 sui-mr-3 sui-hidden lg:sui-block">
            <div className="sui-bg-primary sui-sticky sui-top-0 sui-z-10">
              <SummaryPanel />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

KitchenEstimator.propTypes = {
  data: PropTypes.shape({
    config: PropTypes.shape({
      breadcrumbs: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }),
};

KitchenEstimator.defaultProps = {
  data: {},
};

KitchenEstimator.displayName = 'KitchenEstimator';
